import { ContentfulTooltip } from '@jbhi-fi/apis/src/contentful/types';
import { TooltipProps } from '@jbhi-fi/lanyard-ui/components/Tooltip/Tooltip';

export abstract class TooltipTransformer {
  static toTooltipProps = (entry: ContentfulTooltip): TooltipProps => {
    const tooltipProps = {
      position: entry?.fields?.place ?? 'top',
      message: entry?.fields?.message ?? '',
      openByDefault: entry?.fields?.showByDefault ?? false,
      hideBorderRadius: !entry?.fields?.borderRadius ?? false,
      closeOnlyOnTooltipClick: entry?.fields?.closeOnlyOnClick ?? false,
      anchorSelect: entry?.fields?.elementClass ?? '',
      showOnHover: entry?.fields?.showOnHover ?? false,
      hideCloseButton: entry?.fields?.hideCloseButton ?? true,
      backgroundColor: `#${entry?.fields?.theme?.fields?.backgroundColourHex ?? ''}`,
      fontColor: `#${entry?.fields?.theme?.fields?.textColourHex ?? ''}`,
      shouldHideArrow: entry?.fields?.shouldHideArrow ?? false,
      isAnimationEnabled: entry?.fields?.isAnimationEnabled ?? false,
      isTooltipOut: entry?.fields?.isTooltipOut ?? false,
      borderRadius: entry?.fields?.accurateBorderRadius ?? '',
      transition: entry?.fields?.transition ?? 'from-right',
    };
    return tooltipProps;
  };
}
